/**
 * @generated SignedSource<<bd9b674f6b2523a3415b2e1107b92da7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ObjectiveListInputQuery$variables = {
  node?: string | null;
  title?: string | null;
};
export type ObjectiveListInputQuery$data = {
  readonly objectivesParentSearch: ReadonlyArray<{
    readonly cycle: {
      readonly endDate: string | null;
      readonly startDate: string | null;
    } | null;
    readonly id: string;
    readonly level: number;
    readonly title: string;
  }> | null;
};
export type ObjectiveListInputQuery = {
  response: ObjectiveListInputQuery$data;
  variables: ObjectiveListInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "node"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "forNode",
    "variableName": "node"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectiveListInputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Objective",
        "kind": "LinkedField",
        "name": "objectivesParentSearch",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Cycle",
            "kind": "LinkedField",
            "name": "cycle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectiveListInputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Objective",
        "kind": "LinkedField",
        "name": "objectivesParentSearch",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Cycle",
            "kind": "LinkedField",
            "name": "cycle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4720d6040b5e115893b395456cbe7135",
    "id": null,
    "metadata": {},
    "name": "ObjectiveListInputQuery",
    "operationKind": "query",
    "text": "query ObjectiveListInputQuery(\n  $node: ID\n  $title: String\n) {\n  objectivesParentSearch(forNode: $node, title: $title) {\n    id\n    title\n    level\n    cycle {\n      startDate\n      endDate\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcba6936694e7bc88bc15a4a7482a90c";

export default node;
